import * as React from "react";
import cx from "classnames";
import Text from "components/LegacyText";
import styles from "./styles.scss";
import Icon from "components/Icon";
import checkIcon from "assets/check.svg";
import { ProgramFormStatus } from "../Context";

export interface ToastConfig {
  message: string;
  icon: typeof checkIcon;
  color: string;
}

interface ToastComponentProps {
  status: ProgramFormStatus;
  toastConfigs: Record<string, ToastConfig>;
  helperMargins?: boolean;
}

const ToastComponent = ({ status, toastConfigs }: ToastComponentProps) => {
  const [visibleToast, setVisibleToast] = React.useState<string | null>(null);
  const [isAnimatingOut, setIsAnimatingOut] = React.useState(false);

  const validStatuses = Object.keys(toastConfigs);

  React.useEffect(() => {
    if (validStatuses.includes(status)) {
      setVisibleToast(status);
      setIsAnimatingOut(false);

      const hideTimer = setTimeout(() => {
        setIsAnimatingOut(true);
        setTimeout(() => {
          setVisibleToast(null);
        }, 500);
      }, 2000);

      return () => clearTimeout(hideTimer);
    }
  }, [status]);

  const handleClick = () => {
    setVisibleToast(null);
  };

  if (!visibleToast) {
    return null;
  }

  const { message, icon, color } = toastConfigs[visibleToast];

  return (
    <div
      className={cx(styles.toast, isAnimatingOut && styles.toastOut)}
      onClick={handleClick}
    >
      <div className={styles.toastContent}>
        <Icon src={icon} size={18} fill={color} />
        <Text.P5 kind={"secondary"}>{message}</Text.P5>
      </div>
    </div>
  );
};

export default ToastComponent;
